// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const arcgisBaseUrl = `https://enterprise.arcgis-${_ENV_}.airworks.io`;

// Map environment to layer naming convention
const envLayerMap: Record<string, { folder: string; table: string }> = {
  dev: { folder: 'AW_DEV_Layers', table: 'TablesAndLayers_Dev' },
  test: { folder: 'AW_TEST_Layers', table: 'TablesAndLayers_Test' },
  production: { folder: 'AW_PROD_Layers', table: 'TablesAndLayers_Prod' },
};

const { folder: layerFolder, table: layerTable } = envLayerMap[_ENV_] || envLayerMap.dev;
const layerBasePath = `${arcgisBaseUrl}/server/rest/services/${layerFolder}/${layerTable}`;
const layerFtBasePath = `${arcgisBaseUrl}/server/rest/services/${layerFolder}/${layerTable}_ft`;

const config = {
  portalUrl: `${arcgisBaseUrl}/portal`,
  cadlayerUrl: `${layerBasePath}/MapServer`,
  laslayerUrl: `${layerBasePath}/FeatureServer`,
  site_id: '',
  layerServiceUrl: `${layerBasePath}/MapServer`,
  fl: `${layerBasePath}/MapServer/3`,
  text3Dlayer: `${layerBasePath}/FeatureServer/0`,
  point3dLayer: `${layerBasePath}/FeatureServer/1`,
  polyline3dLayer: `${layerBasePath}/FeatureServer/2`,
  polygon3dLayer: `${layerBasePath}/FeatureServer/3`,
  text3DftLayer: `${layerFtBasePath}/FeatureServer/0`,
  point3dftLayer: `${layerFtBasePath}/FeatureServer/1`,
  polyline3dftlayer: `${layerFtBasePath}/FeatureServer/2`,
  polygon3dftLayer: `${layerFtBasePath}/FeatureServer/3`,
  identifyUrl: `${layerBasePath}/MapServer`,
  layersUrl: `${layerBasePath}/MapServer/4`,
  layersUrlFt: `${layerFtBasePath}/FeatureServer/4`,
  airworks_SupportUrl: 'https://airworksus.atlassian.net/servicedesk/customer/portal/3/group/4/create/15',
  has3dCountUrl: `${layerBasePath}/FeatureServer/3`,
  panoConfig: {
    autoLoad: true,
    showControls: true,
    hfov: 110,
    pitch: 0,
    yaw: 0,
    uiText: {
      fileAccessError: `
      <strong>Error loading Pano viewer</strong><br>
      Image file not found or inaccessible.<br>
    `,
      noPanoramaError: `
      <strong>Error loading Pano viewer</strong><br>
      Image file not found or inaccessible.<br>
    `,
    },
    sceneFadeDuration: true,
  },

  pointoutFields: ['layer_id', 'site_id'],
  polylineoutFields: ['layer_id', 'site_id'],
  polygonoutFields: ['layer_id', 'site_id'],
  textoutFields: ['font_size'],
  has3dField: ['has3d'],
  has3dStatistics: [{
    statisticType: 'count',
    onStatisticField: 'gid',
    outStatisticFieldName: 'count',
  }],
  layersoutFields: {
    color: 'color',
    line_type: 'line_type',
    line_width: 'line_width',
    name: 'name',
    id: 'id',
  },

  layersoutFields_Arr: ['color', 'line_type', 'line_width', 'name', 'id'],

  dashPatterns: {
    CONTINUOUS: 'solid',
    CENTER: 'dash-dot',
    CENTERX2: 'long-dash-dot',
    CENTER2: 'short-dash-dot',
    DASHED: 'short-dash',
    DASHEDX2: 'long-dash',
    DASHED2: 'short-dash',
    PHANTOM: 'short-dash-dot-dot',
    PHANTOMX2: 'short-dash-dot-dot',
    PHANTOM2: 'long-dash-dot-dot',
    DASHDOT: 'short-dash-dot',
    DASHDOTX2: 'long-dash-dot',
    DASHDOT2: 'short-dash-dot',
    DOT: 'dot',
    DOTX2: 'dot',
    DOT2: 'short-dot',
    DIVIDE: 'short-dash-dot-dot',
    DIVIDEX2: 'long-dash-dot-dot',
    DIVIDE2: 'short-dash-dot-dot',
  },
};

export default config;
